import { z } from "zod";
import type { Translations } from "../i18n";

export const createCustomerInfoSchema = (t: Translations) =>
  z.object({
    firstName: z.string().min(1, t.validation.firstNameRequired),
    lastName: z.string().min(1, t.validation.lastNameRequired),
    email: z.string().email(t.validation.emailInvalid),
    phone: z.string().min(10, t.validation.phoneMinLength),
    cgv: z.boolean().refine((val) => val === true, {
      message: t.validation.cgvRequired,
    }),
    isCgvPresta: z.string(),
    cgvPresta: z.boolean().optional(),
    tickets: z.record(z.string(), z.number()),
    additionalFieldsData: z
      .array(
        z.object({
          unitId: z.string(),
          unitName: z.string(),
          ticketNumber: z.number(),
          fields: z.record(z.string(), z.string()),
        })
      )
      .optional(),
  });

// Keep a default export for backward compatibility (uses French messages)
import frFR from "../i18n/locales/fr-FR.json";
export const CustomerInfoSchema = createCustomerInfoSchema(frFR);

export type CustomerInfoSchemaType = z.infer<typeof CustomerInfoSchema>;
